import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

const Layout = ({ role }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const studentNav = [
    { path: '/student', label: 'Dashboard', icon: '🏠' },
    { path: '/student/book', label: 'Book a Lesson', icon: '📅' },
    { path: '/student/bookings', label: 'My Lessons', icon: '📚' },
  ];

  const teacherNav = [
    { path: '/teacher', label: 'Dashboard', icon: '🏠' },
    { path: '/teacher/students', label: 'Students', icon: '👥' },
    { path: '/teacher/schedule', label: 'Schedule', icon: '📅' },
    { path: '/teacher/lessons', label: 'Lessons', icon: '📝' },
  ];

  const adminNav = [
    { path: '/admin', label: 'Dashboard', icon: '🏠' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
    { path: '/admin/bookings', label: 'Bookings', icon: '📅' },
    { path: '/admin/courses', label: 'Courses', icon: '📚' },
    { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
  ];

  const navItems = role === 'admin' ? adminNav : role === 'teacher' ? teacherNav : studentNav;

  return (
    <div className="layout">
      {/* サイドバー */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <Link to="/" className="sidebar-logo">
            <span className="logo-en">Japanese</span>
            <span className="logo-en">Learning</span>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <div className="nav-text">
                <span className="nav-label">{item.label}</span>
              </div>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            {user?.profile_picture ? (
              <img src={user.profile_picture} alt="" className="user-avatar" />
            ) : (
              <div className="user-avatar-placeholder">
                {user?.name?.charAt(0) || '?'}
              </div>
            )}
            <div className="user-details">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">
                {user?.role === 'admin' ? 'Admin' : user?.role === 'teacher' ? 'Teacher' : 'Student'}
              </span>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      {/* メインコンテンツ */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
